<template>
  <div class="yh-page">
    <el-card class="pt-3" v-loading="loading" :element-loading-text="loadingText">
      <el-form :rules="rules" ref="dataForm" :model="new_billing_record" label-position="right" label-width="160px">
        <el-row>
          <el-col :span="11" >

            <!-- 保单号 -->
            <el-form-item label="保单号" prop="policy_number">
              <el-input v-model="new_billing_record.policy_number" placeholder="请输入保单号" ></el-input>
            </el-form-item>

            <!-- 船舶名称 -->
            <!-- <el-form-item label="船舶名称" prop="ship_name">
              <el-input v-model="new_billing_record.ship_name" placeholder="请输入船舶名称" ></el-input>
            </el-form-item>   -->

            <!-- 险种 -->
            <!-- <el-form-item label="险种" prop="insruance_type">
              <el-input v-model="new_billing_record.insruance_type" placeholder="请输入险种" ></el-input>
            </el-form-item>   -->

            <!-- 客户 -->
            <!-- <el-form-item label="客户" prop="client">
              <el-input v-model="new_billing_record.client" placeholder="请输入客户" ></el-input>
            </el-form-item> -->

            <!-- 含税保费 -->
            <el-form-item label="含税保费" prop="premium">
              <el-input v-model="new_billing_record.premium" placeholder="请输入含税保费" ></el-input>
            </el-form-item>                                                        

            <!-- 不含税保费 -->
            <!-- <el-form-item label="不含税保费" prop="tax_free_premium">
              <el-input v-model="new_billing_record.tax_free_premium" placeholder="请输入不含税保费" ></el-input>
            </el-form-item>                                                         -->

            <!-- 出单时间 -->
            <el-form-item  label="出单时间" prop="paid_time">
              <el-date-picker v-model="new_billing_record.paid_time"
                              type="date" value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="出单时间" class="w-100"></el-date-picker>
            </el-form-item>

            <!-- 比例 -->
            <el-form-item label="手续费比例" prop="commission_rate">
              <el-input v-model="new_billing_record.commission_rate" placeholder="请输入手续费比例" ></el-input>
            </el-form-item>               

            <!-- 含税手续费 -->
            <el-form-item label="含税手续费" prop="commission">
              <el-input v-model="new_billing_record.commission" placeholder="请输入含税手续费" ></el-input>
            </el-form-item>    

            <!-- 不含税手续费 -->
            <!-- <el-form-item label="不含税手续费" prop="tax_free_commission">
              <el-input v-model="new_billing_record.tax_free_commission" placeholder="请输入不含税手续费" ></el-input>
            </el-form-item>                                  -->
            
          </el-col>

          <el-col :span="11" >
                   
          </el-col>          
        </el-row>

        <el-row>
          <el-col :span="24" class="border-top mt-2 pt-3">
            <el-form-item>
              <el-button size="small" @click="cancelData">取消</el-button>
              <el-button v-if="pageStatus == 'action.edit' && showEdit" size="small"
                         type="primary" @click="updateData">保存
              </el-button>
              <template v-if="pageStatus == 'action.add' && showAdd">
                <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
                <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
  import {createBillingRecord, fetchBillingRecord, updateBillingRecord} from '@/api/billing'  
  import {validateMobileNumber} from '@/utils/validate'


  export default {
    name: "billing-record",
    components: {

    },

    data() {
      return {
        rules: {
          // name: [{required: true, message: '请输入客户名称', trigger: 'blur'}],
          // type: [{required: true, message: '请选择客户类型', trigger: 'blur'}],
          // actual_controller: [{required: true, message: '请输入实际控制人信息', trigger: 'blur'}],
          // contact: [{required: true, message: '请输入联系人信息', trigger: 'blur'}],
          // mobile: [{required: true, message: '请输入有效的手机号码', trigger: 'blur', validator: validateMobileNumber}]
        },
        showAdd: false,
        showEdit: false,
        loading: false,
        loadingText: '正在加载数据，请销等...',
        new_billing_record: {
          // ship_name:"",
          // insruance_type:"",
          company:"",
          premium:"",
          // tax_free_premium:"",
          paid_time:"",
          commission_rate:"",
          commission:"",
          // tax_free_commission:"",
          billing_file: 0
        },
        pageStatus: 'action.add',
        company: '',
        fileId: 0,
        id: 0
      }
    },

    methods: {
      reset_new_billing_record() {
        this.new_billing_record = {}
      },
      showCreateView() {
        this.pageStatus = 'action.add'
        this.reset_new_billing_record()
      },
      showUpdateView(company, id) {
        this.pageStatus = 'action.edit'
        fetchBillingRecord(company, id)
          .then(res => {
            this.new_billing_record = Object.assign({}, res)
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          })
          .catch(error => {
            this.$message.error(error)
          })
      },
      cancelData() {
        this.$refs.dataForm.resetFields()
        this.reset_new_billing_record()
        this.$router.go(-1)
        // this.$router.push({name: 'billingList'})
      },
      createData(type) {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.loading = true
            this.loadingText = '正在保存账单数据，请稍等...'
            this.new_billing_record.billing_file = this.fileId
            createBillingRecord(this.new_billing_record, this.company, this.fileId) .then(res => {
                this.billingId = res.id
                this.loadingText = "保存账单信息成功"
              })
              .then(() => {
                this.loading = false
                this.$message.success('保存账单成功')
                this.$nextTick(() => {
                  this.$refs.dataForm.clearValidate()
                  this.$refs.dataForm.resetFields()
                  this.reset_new_billing_record()
                  if (type == 1) {
                    // this.$router.push({name: 'billingList'})
                    this.$router.go(-1)
                  }
                })
              })
              .catch(error => {
                this.saving = false
                this.$message.error(error)
              })
          }
        })
      },
      updateData() {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            const new_billing_record = Object.assign({}, this.new_billing_record)
            updateBillingRecord(new_billing_record, this.company, new_billing_record.id )
              .then(() => {
                this.$message.success('更新账单信息成功')
                this.$nextTick(() => {
                  this.$refs.dataForm.clearValidate()
                  this.$refs.dataForm.resetFields()
                  this.reset_new_billing_record()
                  setTimeout(() => {
                    //this.$router.push({name: 'billingList'})
                    this.$router.go(-1)
                  }, 200)
                })
              })
              .catch(error => {
                this.$message.error(error)
              })
          }
        })
      }
    },
    created() {
      // 入参检查
      if (this.$route.query.company === undefined || this.$route.query.fileId === undefined){
        this.$router.push('/404')
      }
      this.company = this.$route.query.company
      this.fileId= this.$route.query.fileId

      // 处理新增
      if (this.$route.name == 'createBillingRecord') {
        if (!this.$perm(["billing.create_billing_record"])) {
          this.$router.push('/401')
        }
        this.showAdd = true
        this.showCreateView()
        return 
      } 

      // 处理更新
      if (!this.$perm(["billing.update_billing_record"])) {
        this.$router.push('/401')
      }
      if (this.$route.query.id === undefined){
        this.$router.push('/404')
      }
      this.id = this.$route.query.id
      this.showEdit = true
      this.showUpdateView(this.company, this.id)
    }
  }
</script>
